module.exports = __webpack_public_path__ + "static/img/HXCX_H5.4a93f20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/HXCX_H5.png
// module id = Lwv8
// module chunks = 34